import { __extends } from "tslib";
import { ASError } from '@awayfl/avm2';
var InvalidSWFError = /** @class */ (function (_super) {
    __extends(InvalidSWFError, _super);
    function InvalidSWFError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    InvalidSWFError.classInitializer = null;
    // List of static symbols to link.
    InvalidSWFError.classSymbols = null; // [];
    // List of instance symbols to link.
    InvalidSWFError.instanceSymbols = null; // [];
    return InvalidSWFError;
}(ASError));
export { InvalidSWFError };
